<template>
  <div class="dynamic-tables">
    <h2 class="page-title">Permohonan Usaha Mikro Kecil</h2>
    <Widget customHeader>
      <div>
        <table id="example" class="table" style="width: 100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Jenis Kegiatan</th>
              <th>Lokasi</th>

              <th>Tgl. Permohonan</th>
              <th>Status Permohonan</th>
              <th>File</th>
              <th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(data, index) in dataPermohonan" :key="index">
              <td></td>
              <!-- <td>
                <span
                  class="badge rounded-pill bg-success"
                  style="font-size: 10px; font-weight: normal"
                  v-if="data.nomor_permohonan != null"
                  >{{ data.nomor_permohonan }}</span
                >
                <span
                  class="badge rounded-pill bg-danger"
                  style="
                    font-size: 10px;
                    font-weight: normal;
                    background-color: #ff6e7c !important;
                  "
                  v-else
                  >Belum Ada</span
                >
              </td> -->
              <td>{{ data.jenis_kegiatan }}</td>
              <td>{{ data.nama_perairan }}</td>

              <td>
                {{ format_date(data.tanggal_permohonan, 'DD MMM YYYY') }}
              </td>
              <!-- <td>
                <span v-if="data.status_tagihan_iii != null">
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_iii, "DD MMMM YYYY") }}
                </span>
                <span
                  v-else-if="
                    data.status_tagihan_ii != null &&
                    data.status_tagihan_i != null
                  "
                >
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_ii, "DD MMMM YYYY") }}
                </span>
                <span v-else>
                  {{ format_date(data.tanggal_berlaku_hingga_tagihan_i, "DD MMMM YYYY") }}
                </span>
              </td> -->
              <td>
                {{ data.status }}
              </td>
              <td>
                <div style="width: 250px" class="row">
                  <div class="col-8">
                    <b-button
                      :id="'popover-reactive-' + data.id"
                      variant="primary"
                      ref="button"
                    >
                      Unduh Dokumen
                    </b-button>
                    <b-popover
                      :target="'popover-reactive-' + data.id"
                      triggers="hover"
                      :show.sync="popoverShow[data.id]"
                      placement="auto"
                      container="my-container"
                      ref="popover"
                    >
                      <template #title>
                        <b-button
                          @click="onClose(data.id)"
                          class="close"
                          aria-label="Close"
                        >
                          <span class="d-inline-block" aria-hidden="true"
                            >&times;</span
                          >
                        </b-button>
                        Unduh Dokumen
                      </template>
                      <div
                        v-if="
                          data.filename_final_undangan != null ||
                          data.file_persetujuan != null
                        "
                      >
                        <b-list-group>
                          <b-list-group-item
                            button
                            class="text-success"
                            v-if="data.file_tagihan_iii != null"
                          >
                            <a :href="data.file_tagihan_iii" target="_blank">
                              <i class="fa fa-cloud-download"></i> Tagihan</a
                            ></b-list-group-item
                          >
                          <b-list-group-item
                            button
                            class="text-success"
                            v-else-if="
                              data.file_tagihan_ii != null &&
                              data.file_tagihan_i != null
                            "
                          >
                            <a :href="data.file_tagihan_ii" target="_blank">
                              <i class="fa fa-cloud-download"></i> Tagihan</a
                            ></b-list-group-item
                          >
                          <b-list-group-item
                            button
                            class="text-success"
                            v-else-if="data.file_tagihan_i != null"
                          >
                            <a :href="data.file_tagihan_i" target="_blank">
                              <i class="fa fa-cloud-download"></i> Tagihan</a
                            ></b-list-group-item
                          >

                          <b-list-group-item
                            button
                            class="text-success"
                            v-if="data.bukti_pembayaran != null"
                          >
                            <a :href="data.bukti_pembayaran" target="_blank"
                              ><i class="fa fa-cloud-download"></i> Bukti
                              Pembayaran</a
                            >
                          </b-list-group-item>
                          <b-list-group-item
                            button
                            class="text-success"
                            v-if="data.filename_final_undangan != null"
                            ><a
                              :href="data.filename_final_undangan"
                              target="_blank"
                            >
                              <i class="fa fa-cloud-download"></i> Undangan</a
                            ></b-list-group-item
                          >
                          <b-list-group-item
                            button
                            class="text-success"
                            v-if="data.file_izin_ttd != null"
                          >
                            <a :href="data.file_izin_ttd" target="_blank">
                              <i class="fa fa-cloud-download"></i> Surat
                              Persetujuan</a
                            ></b-list-group-item
                          >
                        </b-list-group>
                      </div>
                      <div v-else>
                        <span>Tidak ada file untuk diunduh</span>
                      </div>
                    </b-popover>
                  </div>
                  <!-- <b-form-select style="width: 150px;margin-right: 20px;" v-model="data.selectedFile"
                  :options="optionsFile"></b-form-select> -->

                  <div class="col-4 mt-2">
                    <span
                      v-if="
                        data.file_tagihan_iii != null &&
                        data.selectedFile == 'tagihan'
                      "
                    >
                      <a :href="data.file_tagihan_iii" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file tagihan"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.file_tagihan_ii != null &&
                        data.file_tagihan_i != null &&
                        data.selectedFile == 'tagihan'
                      "
                    >
                      <a :href="data.file_tagihan_ii" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file tagihan"
                        />
                      </a>
                    </span>
                    <span
                      v-else-if="
                        data.file_tagihan_i != null &&
                        data.selectedFile == 'tagihan'
                      "
                    >
                      <a :href="data.file_tagihan_i" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file tagihan"
                      /></a>
                    </span>

                    <!-- <br> -->
                    <span
                      v-if="
                        data.bukti_pembayaran != null &&
                        data.selectedFile == 'pembayaran'
                      "
                    >
                      <a :href="data.bukti_pembayaran" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file bukti pembayaran"
                        />
                      </a>
                    </span>

                    <span
                      v-if="
                        data.filename_final_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      "
                    >
                      <a :href="data.filename_final_surat_tugas" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file surat tugas"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.filename_konsep_surat_tugas != null &&
                        data.selectedFile == 'surattugas'
                      "
                    >
                      <a
                        :href="data.filename_konsep_surat_tugas"
                        target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file surat tugas"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.filename_final_undangan != null &&
                        data.selectedFile == 'undangan'
                      "
                    >
                      <a :href="data.filename_final_undangan" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file undangan"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.filename_konsep_undangan != null &&
                        data.selectedFile == 'undangan'
                      "
                    >
                      <a :href="data.filename_konsep_undangan" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file undangan"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.file_ba_vertek != null && data.selectedFile == 'ba'
                      "
                    >
                      <a :href="data.file_ba_vertek" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file berita acara"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.file_final_memorandum != null &&
                        data.selectedFile == 'memo'
                      "
                    >
                      <a :href="data.file_final_memorandum" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file memo"
                      /></a>
                    </span>
                    <span
                      v-else-if="
                        data.file_konsep_memorandum != null &&
                        data.selectedFile == 'memo'
                      "
                    >
                      <a :href="data.file_konsep_memorandum" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file memo"
                      /></a>
                    </span>

                    <span
                      v-if="
                        data.file_persetujuan != null &&
                        data.selectedFile == 'persetujuan'
                      "
                    >
                      <a :href="data.file_persetujuan" target="_blank"
                        ><i
                          class="fa fa-download"
                          aria-hidden="true"
                          style="font-size: 20px"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Unduh file persetujuan"
                        />
                      </a>
                    </span>
                  </div>
                </div>
              </td>
              <td>
                <div style="width: 200px">
                  <b-button-toolbar>
                    
                    <span
                      class="d-none d-md-inline-block text-warning text-bold m-2"
                      style="cursor: pointer"
                      @click="edit(data.id)"
                    >
                      <i class="fa fa-edit"></i> Edit</span
                    >
                    <span
                      class="d-none d-md-inline-block text-danger text-bold m-2"
                      style="cursor: pointer"
                      @click="deletePermohonan(data.id)"
                    >
                      <i class="fa fa-trash"></i> Delete</span
                    >
                  </b-button-toolbar>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Widget>
    <b-modal
      id="modal-tracking"
      title="Tracking Permohonan"
      size="lg"
      scrollable
    >
      <template v-if="progressPermohonan.length == 0">
        <span class="text-center">Maaf, tidak ada data</span>
      </template>
      <template v-else>
        <ul class="timeline">
          <li v-for="(data, index) in progressPermohonan" :key="index">
            <!-- <time class="eventTime" dateTime="2014-05-19 03:04">
            <span class="date">today</span>
            <span class="time">9:41 <span class="fw-semi-bold">am</span></span>
          </time> -->
            <span class="eventIcon eventIconPrimary">
              <!-- <i class="la la-lg la-comment" /> -->
            </span>
            <section class="event">
              <span class="thumb-xs avatar pull-left me-sm-1"> </span>
              <h5 class="eventHeading">
                <!-- <a href="#" v-if="index == 0">Submit Permohonan</a> -->
                <a href="#">{{ data.status_permohonan }}</a>
              </h5>
              <small>{{ data.nama_pemohon }}</small>

              <p class="fs-sm text-muted">
                {{ format_date(data.createdAt, 'HH:mm - DD MMMM YYYY') }}
              </p>

              <div class="text-danger" v-html="data.catatan"></div>
            </section>
          </li>
        </ul>
      </template>
      <template #modal-footer>
        <div class="w-100">
          <b-button
            variant="danger"
            size="sm"
            class="float-right"
            @click="$bvModal.hide('modal-tracking')"
          >
            Tutup
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<style>
table.table.b-table > thead > tr > th[aria-sort='ascending']::after,
table.table.b-table > tfoot > tr > th[aria-sort='ascending']::after {
  opacity: 1;
  content: '\2191';
}

.dt-button.btn.btn-primary {
  border: none;
}

.dt-button.btn.btn-primary:hover {
  background-color: #35a0fd !important;
  border: none;
}
</style>

<script>
import Widget from '@/components/Widget/Widget'
import Swal from 'sweetalert2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import vSelect from 'vue-select'
import axios from 'axios'
import VueLoading from 'vuejs-loading-plugin'
import Vue from 'vue'
import moment from 'moment'
import { formatDate } from '../../helper/helpernew'

// using default options
Vue.use(VueLoading)

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'], // array, object or string
})

export default {
  name: 'Dynamic',
  components: { Widget, ClassicEditor, vSelect },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      dataPermohonan: [],
      progressPermohonan: [],
      popoverShow: {},
    }
  },

  mounted() {
    this.loaddata()
  },
  methods: {
    onClose(id) {
      this.popoverShow[id] = false
    },
    
    format_date(val, format) {

      if (val) return moment(String(val)).format(format);
    },
    loaddata() {
      axios
        .get(
          this.baseapi +
            'api/permohonan_umk?filter=id_pembuat,=,' +
            this.user.id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          this.dataPermohonan = response.data.data
          console.log(this.dataPermohonan)
          this.initDatatable()
        })
        .catch((error) => {
          console.log(error)
          return error
        })
    },
    async deletePermohonan(id) {
      Swal.fire({
        title: 'Apa kamu yakin?',
        text: 'Anda tidak akan dapat mengembalikan data ini!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya, hapus',
        cancelButtonText: 'Tutup',
      }).then(async (result) => {
        if (result.isConfirmed) {
          axios
            .delete(this.baseapi + 'api/permohonan_umk/' + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken,
              },
            })
            .then((response) => {
              Swal.fire('Berhasil', '' + response.data.message + '', 'success')
              $('#example').DataTable().destroy()
              this.loaddata()
            })
            .catch((error) => {
              console.log(error)
            })
        }
      })
    },
    edit(id) {
      localStorage.setItem('id_permohonan', id)
      localStorage.setItem('tipe_pemohon', 'UMK')
      this.$router.push('/app/permohonan/form-umk')
    },

    loadProgress(id) {
      axios
        .get(
          this.baseapi +
            'api/status_permohonan_umk?filter=id_permohonan,=,' +
            id,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          }
        )
        .then((response) => {
          console.log(response.data.data)
          this.progressPermohonan = response.data.data
          this.$bvModal.show('modal-tracking')
        })
        .catch((error) => {
          console.log(error)
          return error
        })
    },
    initDatatable() {
      setTimeout(() => {
        $.fn.dataTable.moment('DD MMM YYYY');
        var t = $('#example').DataTable({
          pagingType: 'full_numbers',
          language: {
            info: 'Menampilkan _START_ sampai _END_ dari _TOTAL_ data',
            paginate: {
              first: 'Awal',
              last: 'Akhir',
              next: 'Selanjutnya',
              previous: 'Sebelumnya',
            },
          },
          
          responsive: true,
          destroy: true,
          retrieve: true,
          autoFill: true,
          colReorder: true,
          fixedColumns: { left: 2, right: 1 },
          scrollX: true,
          dom: 'Bfrtip',
          fnRowCallback: function (
            nRow,
            aData,
            iDisplayIndex,
            iDisplayIndexFull
          ) {
            //debugger;
            var index = iDisplayIndexFull + 1
            $('td:first', nRow).html(index)
            return nRow
          },
          columnDefs: [
            {
              targets: 0,
              render: function (data, type, row, meta) {
                // console.log(meta.row);
                // console.log(type == 'export' ? meta.row : data);
                return type == 'export' ? meta.row + 1 : data
              },
              rowCallback: function (row, data, index) {
                console.log(data)
                if (data[0] == 'OK') {
                  $(row).addClass('green')
                } else if (data[0] == 'Before') {
                  $(row).addClass('orange')
                }
              },
            },
          ],
          buttons: [
            // 'excel', 'pdf',
            {
              text: '<i class="fa fa-plus"></i> Tambah',
              className: 'btn btn-primary',
              action: function (e, dt, node, config) {
                localStorage.removeItem('id_permohonan')
                localStorage.setItem('tipe_pemohon', 'UMK')
                window.location = '/app/permohonan/form-umk'
              },
            },
            {
              extend: 'excelHtml5',
              title: 'DATA PEMOHON',
              text: '<i class="fa fa-file-text-o"></i> Excel',
              className: 'btn text-white btn-success',
              exportOptions: {
                columns: [1, 2, 3, 4, 5, 6, 7, 8, 9],
                orthogonal: 'export',
              },
              filename: function () {
                var today = new Date()
                // var n = d.getTime();
                var date =
                  today.getFullYear() +
                  '-' +
                  (today.getMonth() + 1) +
                  '-' +
                  today.getDate()

                return 'Data Pemohon ' + date
              },
            },
          ],
        })

        t.on('order.dt search.dt', function () {
          t.column(0, { search: 'applied', order: 'applied' })
            .nodes()
            .each(function (cell, i) {
              cell.innerHTML = i + 1
            })
        }).draw()
      }, 300)
    },
  },
}
</script>

<style src="./Elements.scss" lang="scss" />
